import getProductConfigCrossSelling from '@services/cross-selling/getProductConfigCrossSelling';
import getCartId from '@core/reducers/cart/selectors/getCartId';
import { mapperSection } from '@services/menu/niles/mapperV2';
import { error as logError } from '@logger';

const fetchProducts = async (axios, shopId, productId, cartId) => {
  const { success, data, error } = await getProductConfigCrossSelling({
    axios,
    shopId,
    productId,
    cartId,
  });

  if (success) {
    const { products } = mapperSection(data?.section);
    return { ...data?.section, products };
  }

  logError('[FETCH_PRODUCT_CROSSELLING]', {
    error,
  });

  return null;
};

const fetchProductCrossSelling = (shopId, productId) => async (
  _,
  getState,
  axios,
) => {
  try {
    const state = getState();
    const cartId = getCartId(state);
    return fetchProducts(axios, shopId, productId, cartId);
  } catch (error) {
    logError('[FETCH_PRODUCT_CROSSELLING]', { error });
  }

  return null;
};

export default fetchProductCrossSelling;
